const oAuthStorage = {
  setAuthEmail: (email) => {
    window.sessionStorage.setItem('auth_email', email);
  },
  getAuthEmail: () => {
    const authEmail = window.sessionStorage.getItem('auth_email');
    window.sessionStorage.removeItem('auth_email');
    return authEmail;
  },
  setState: (state) => {
    window.sessionStorage.setItem('oauth_state', state);
    window.sessionStorage.setItem('auth_is_started', 'true');
  },
  getState: () => {
    const oAuthState = window.sessionStorage.getItem('oauth_state');
    const hasInitOAuth = window.sessionStorage.getItem('auth_is_started');

    window.sessionStorage.removeItem('auth_is_started');
    window.sessionStorage.removeItem('oauth_state');

    return { oAuthState, hasInitOAuth };
  },
  setInitiatedAuthStatus: (status) => {
    window.sessionStorage.setItem('initiated_auth', status);
  },
  getInitiatedAuthStatus: () => {
    const initiated_auth = window.sessionStorage.getItem('initiated_auth');
    return initiated_auth;
  },
  deleteInitiatedAuthStatus: () => {
    window.sessionStorage.removeItem('initiated_auth');
    window.sessionStorage.removeItem('auth_is_started');
  },
  setPKCE: (privateKey) => {
    window.sessionStorage.setItem('oauth_pkce_key', privateKey);
  },
  getPKCE: () => {
    const oAuthPkceKey = window.sessionStorage.getItem('oauth_pkce_key');
    window.sessionStorage.removeItem('oauth_pkce_key');
    return oAuthPkceKey;
  },
  setDeepLink: (url) => {
    window.sessionStorage.setItem('deep_link', url);
  },
  // Read without consuming, for analytics on the sign-in screen (getDeepLink clears it)
  peekDeepLink: () => window.sessionStorage.getItem('deep_link'),
  getDeepLink: () => {
    const deepLink = window.sessionStorage.getItem('deep_link');
    window.sessionStorage.removeItem('deep_link');
    return deepLink;
  },
  setImpersonation: (impersonation) => {
    if (impersonation) {
      window.sessionStorage.setItem('oauth_impersonation', '1');
    } else {
      window.sessionStorage.removeItem('oauth_impersonation');
    }
  },
  isImpersonation: () => window.sessionStorage.getItem('oauth_impersonation') === '1',
  clearAll: () => {
    window.sessionStorage.removeItem('oauth_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
    window.sessionStorage.removeItem('initiated_auth');
    window.sessionStorage.removeItem('auth_email');
    window.sessionStorage.removeItem('oauth_impersonation');
  }
};

export default oAuthStorage;
